import type { ReactNode } from "react";

import { cn } from "../lib/utils";

export interface InlineErrorProps {
  children: ReactNode;
  className?: string;
}

export const InlineError = ({ children, className }: InlineErrorProps) => (
  <div
    role="alert"
    className={cn(
      "rounded-crane-md bg-crane-status-alarm/10 px-3 py-2 text-center text-xs font-medium leading-snug text-crane-status-alarm ring-1 ring-inset ring-crane-status-alarm/30",
      className,
    )}
  >
    {children}
  </div>
);
